import * as types from './mutations-types'

export default {
  [types.MEMBER_INFO_DATA] (state, data) {
    state.memberInfoData = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/store/mutations.js